module.exports = __webpack_public_path__ + "static/img/jcoin01.00f78b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jcoin01.png
// module id = X/AL
// module chunks = 1